import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  headerTitle: {
    id: 'headerTitle',
    defaultMessage: 'Messages',
  },
  headerBody: {
    id: 'headerBody',
    defaultMessage:
      'Get virtual support from your care team. Responses may take 24 hours. If this is a medical emergency, please call 911.',
  },
  newMessage: {
    id: 'newMessage',
    defaultMessage: 'Send a message',
  },
  noMessagesTitle: {
    id: 'noMessagesTitle',
    defaultMessage: 'No messages',
  },
  noMessagesBody: {
    id: 'noMessageBody',
    defaultMessage:
      'Messages from your care team will appear here. Send your care team a message to get virtual support. Responses may take 24 hours. If this is a medical emergency, please call 911.',
  },
});
